import { useMutation } from '@tanstack/react-query'
import axios from 'axios'

const API_BASE_URL = import.meta.env.VITE_API_URL || ''

export function useForgotPassword() {
  return useMutation({
    mutationFn: async (email: string) => {
      const { data } = await axios.post(`${API_BASE_URL}/api/passwords/forgot`, { email })
      return data
    },
  })
}

export function useResetPassword() {
  return useMutation({
    mutationFn: async (input: {
      token: string
      password: string
      password_confirmation: string
    }) => {
      const { data } = await axios.post(`${API_BASE_URL}/api/passwords/reset`, input)
      return data
    },
  })
}
